export const HOME_MOBILE_BREAKPOINT = 644;
